import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const reOpenContractApi = createApi('reopenContracts', 'POST');

const ReOpen = createSlice({
  name: 'ReOpen',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(reOpenContractApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reOpenContractApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(reOpenContractApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ReOpen.reducer;